// The proxy stamps ht_country from Vercel's x-vercel-ip-country header. Absent
// (local dev, header stripped) means restricted campaigns fail closed, while a
// lower-priority global popup remains eligible. Shared by the SitePopups
// controller and the popup_inline embed; browser-only (reads document).
export const visitorCountry = (): string | null => {
  const match = document.cookie.match(/(?:^|;\s*)ht_country=([^;]+)/)
  return match ? decodeURIComponent(match[1]).toUpperCase() : null
}
